export default [
  {label: "ACCOUNTANT/AUDITOR", value: "OA01"},
  {label: "ADJUSTER", value: "OA26"},
  {label: "ADMINISTRATOR", value: "OA03"},
  {label: "ADVISOR", value: "OA11"},
  {label: "AGENT", value: "OA06"},
  {label: "AGRICULTURIST", value: "OA18"},
  {label: "AIRCRAFT CREW", value: "FLIG"},
  {label: "AMBASSADOR", value: "OA10"},
  {label: "ANALYST", value: "OA15"},
  {label: "ANIMATOR", value: "ANIM"},
  {label: "ARCHAEOLOGIST", value: "OA13"},
  {label: "ARCHITECT", value: "TA03"},
  {label: "ARMY", value: "SVCM"},
  {label: "ASSISTANT", value: "OA20"},
  {label: "ATHLETE", value: "OA07"},
  {label: "ATTENDANT", value: "OA24"},
  {label: "BABY SITTER", value: "OB10"},
  {label: "BAKER", value: "BAKE"},
  {label: "BANKER", value: "OB01"},
  {label: "BARTENDER", value: "OB06"},
  {label: "BEAUTICIAN", value: "OB11"},
  {label: "BELLBOY", value: "OB09"},
  {label: "BIOLOGIST", value: "OB08"},
  {label: "BROKER", value: "OB12"},
  {label: "BUILDER/CONSTRUCTOR", value: "BULD"},
  {label: "BUSINESSMAN", value: "OB02"},
  {label: "BUTCHER", value: "OB05"},
  {label: "CADDIE", value: "OC13"},
  {label: "CARETAKER", value: "OC23"},
  {label: "CARGO ATTENDANT", value: "OC28"},
  {label: "CARPENTER", value: "OC01"},
  {label: "CASHIER", value: "OC11"},
  {label: "CATERER", value: "OC12"},
  {label: "CHEF", value: "OC10"},
  {label: "CHEMIST", value: "OC08"},
  {label: "CHIEF EXECUTIVE OFFICER", value: "OC22"},
  {label: "CHIEF OPERATING OFFICER", value: "OC34"},
  {label: "CIVIL SERVANT", value: "CSER"},
  {label: "CLEANER", value: "OC06"},
  {label: "CLERICAL", value: "OC02"},
  {label: "COMMISSIONER", value: "OC17"},
  {label: "CONSULTANT", value: "OC07"},
  {label: "CONTRACTOR", value: "OC03"},
  {label: "CONTROLLER", value: "OC20"},
  {label: "CONVEYOR", value: "OC30"},
  {label: "CO-ORDINATOR", value: "OC16"},
  {label: "COUNSELLOR", value: "OC14"},
  {label: "COUNTER CREW", value: "CREW"},
  {label: "CRAFTSMAN", value: "OC05"},
  {label: "CRANE OPERATOR", value: "CROP"},
  {label: "CROUPIER", value: "OC29"},
  {label: "DEALER", value: "OD01"},
  {label: "DECORATOR", value: "OD10"},
  {label: "DENTIST", value: "DENT"},
  {label: "DERMATOLOGIST", value: "OD05"},
  {label: "DESIGNER", value: "OD06"},
  {label: "DESPATCHER", value: "OD11"},
  {label: "DIRECTOR", value: "DIR"},
  {label: "DISTRIBUTOR", value: "OD13"},
  {label: "DIVER", value: "OD02"},
  {label: "DOCTOR", value: "OD08"},
  {label: "DOMESTIC MAID", value: "DMFW"},
  {label: "DOOR USHER", value: "DOUR"},
  {label: "DRAFTSMAN", value: "OD12"},
  {label: "DRIVER", value: "OD07"},
  {label: "ECONOMIST", value: "OE07"},
  {label: "EDITOR", value: "OE04"},
  {label: "ELECTRICIAN", value: "OE06"},
  {label: "ENGINEER", value: "OE03"},
  {label: "ENTERTAINER", value: "OE05"},
  {label: "EXECUTIVE", value: "OE02"},
  {label: "FACTORY WORKER", value: "OF08"},
  {label: "FARMER", value: "OF02"},
  {label: "FINANCIAL CONTROLLER", value: "FNCT"},
  {label: "FIREMAN", value: "OF04"},
  {label: "FISHERMAN", value: "OF05"},
  {label: "FISHMONGER", value: "OF01"},
  {label: "FITTER", value: "OF09"},
  {label: "FLORIST", value: "OF06"},
  {label: "FOREMAN", value: "OF07"},
  {label: "GARDENER", value: "OG02"},
  {label: "GENERAL WORKER", value: "OG01"},
  {label: "GEOLOGIST", value: "TG01"},
  {label: "GOLD/JEWEL/BLACK SMITH", value: "OG04"},
  {label: "GUARD", value: "OG06"},
  {label: "GUIDE", value: "OG05"},
  {label: "HAIR DRESSER", value: "BARB"},
  {label: "HAWKER", value: "OH02"},
  {label: "HOSPITAL STAFF", value: "OH06"},
  {label: "HOSTESS", value: "OH04"},
  {label: "HOTEL & RESTAURANT STAFF", value: "HRGW"},
  {label: "HOUSEWIFE", value: "OH03"},
  {label: "INSTRUCTOR", value: "OI03"},
  {label: "INVESTIGATOR", value: "PTEI"},
  {label: "IT PROGRAMMER / SYSTEM ANALYST", value: "OP14"},
  {label: "JOCKEY", value: "JOCK"},
  {label: "JOURNALIST", value: "OJ01"},
  {label: "JUDGE", value: "OJ02"},
  {label: "LABORATORIST", value: "OL06"},
  {label: "LANDLORD/LANDLADY", value: "OL07"},
  {label: "LAUNDRY WORKER", value: "TL01"},
  {label: "LECTURER", value: "OL02"},
  {label: "LEGAL PROFESSION", value: "OL01"},
  {label: "LIBRARIAN", value: "OL03"},
  {label: "LIFEGUARD", value: "LFGD"},
  {label: "LUMBERJACK", value: "OL05"},
  {label: "MACHINIST", value: "OM08"},
  {label: "MAGISTRATE", value: "OM19"},
  {label: "MAID/HOUSEKEEPER", value: "OH12"},
  {label: "MAINTENANCE WORKER", value: "OM06"},
  {label: "MANAGERIAL", value: "OM01"},
  {label: "MANUAL WORKER", value: "CBJT"},
  {label: "MARINE/NAVY", value: "OM04"},
  {label: "MARKETEER", value: "OM02"},
  {label: "MARSHALL", value: "OM20"},
  {label: "MASSEUSE", value: "MASS"},
  {label: "MECHANIC", value: "OM03"},
  {label: "MEDICAL PRACTITIONER", value: "OM15"},
  {label: "MIDWIFE", value: "OM23"},
  {label: "MONEY CHANGER", value: "MOCG"},
  {label: "MONEY LENDER", value: "MONL"},
  {label: "NURSE", value: "ON01"},
  {label: "NUTRITIONIST", value: "ON10"},
  {label: "OFFICER", value: "OO03"},
  {label: "OPERATOR", value: "OO01"},
  {label: "OPTICIAN", value: "OO04"},
  {label: "OTHER OCCUPATION", value: "OTHR"},
  {label: "PACKER", value: "OP17"},
  {label: "PAINTER", value: "OP01"},
  {label: "PASTOR", value: "OP13"},
  {label: "PATHOLOGIST", value: "OP10"},
  {label: "PENSIONER/RETIREE", value: "OP02"},
  {label: "PERSONAL ASSISTANT", value: "OP27"},
  {label: "PHARMACIST", value: "OP05"},
  {label: "PHOTOGRAPHER", value: "PGRA"},
  {label: "PILOT", value: "OP07"},
  {label: "PLANNER", value: "OP16"},
  {label: "PLUMBER", value: "OP23"},
  {label: "POLICE", value: "POLM"},
  {label: "POLITICIAN", value: "PLTN"},
  {label: "POSTMAN", value: "OP06"},
  {label: "PRINCIPAL", value: "OP20"},
  {label: "PRINTER", value: "PNTR"},
  {label: "PROFESSOR", value: "PROF"},
  {label: "PROMOTER", value: "OP03"},
  {label: "PSYCHIATRIST", value: "OP04"},
  {label: "PUBLIC SPEAKER", value: "OP28"},
  {label: "PURCHASER", value: "OP09"},
  {label: "RECEPTIONIST", value: "KTVR"},
  {label: "REMISIER", value: "OR04"},
  {label: "RESEARCHER", value: "OR01"},
  {label: "SAILOR", value: "OS11"},
  {label: "SCHEDULER", value: "OS21"},
  {label: "SCIENTIST", value: "OS04"},
  {label: "SECRETARY", value: "OS01"},
  {label: "SELF-EMPLOYED", value: "OS18"},
  {label: "SEWER", value: "OS25"},
  {label: "SINGER", value: "SING"},
  {label: "STEWARD/STEWARDESS", value: "OS19"},
  {label: "STUDENT", value: "OS06"},
  {label: "SUPERINTENDENT", value: "OS20"},
  {label: "SUPERVISOR", value: "OS02"},
  {label: "SURVEYOR", value: "OS05"},
  {label: "TAILOR/ SEAMSTRESS", value: "OS15"},
  {label: "TEACHER", value: "OT04"},
  {label: "TECHNICIAN", value: "OT02"},
  {label: "THERAPIST", value: "OT11"},
  {label: "TOOL SETTER", value: "OS22"},
  {label: "TRADER", value: "OT03"},
  {label: "TRAFFIC WARDEN", value: "OT13"},
  {label: "TRAINER", value: "OT14"},
  {label: "TRANSLATOR", value: "OT10"},
  {label: "TUTOR", value: "OT09"},
  {label: "UNEMPLOYED", value: "UNEM"},
  {label: "VETERINARIAN", value: "OV01"},
  {label: "VISUALISER", value: "OV04"},
  {label: "WAITRESS/WAITER", value: "OW04"},
  {label: "WARDEN", value: "OW06"},
  {label: "WELDER", value: "OW02"},
  {label: "WRITER", value: "OW05"},
  {label: "ZOOLOGIST", value: "OZ01"}
]